
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locations/location-search",
      function () {
        return require("private-next-pages/locations/location-search.tsx");
      }
    ]);
  